<template>
	<div>
		<div class="certificate">
			<div class="certificate-search">
				<el-cascader placeholder="办证项目类型不限" style="margin-right:20px;" v-model="select" :options="selectList"
					@change="handleChange" clearable></el-cascader>
				<el-input v-model="input">
					<!-- <el-select v-model="select" slot="prepend" placeholder="请选择办证类别">
					<el-option label="餐厅名" value="1" v-for="(item,idx) in selectList" :key="idx"></el-option>
					<el-option label="订单号" value="2"></el-option>
					<el-option label="用户电话" value="3"></el-option>
				</el-select> -->
				</el-input>
				<el-button type="primary" @click="search">搜索</el-button>
			</div>
			<div class="certificate-list">
				<div class="certificate-item" v-for="(item, idx) in list" :key="idx">
					<div class="certificate-item-img">
						<img :src="item.icon" width="100%" height="100%" />
					</div>
					<div style="width: 100%;">
						<div class="certificate-item-title">{{ item.name }}</div>
						<div class="certificate-item-name">已服务{{ item.serverNum }}人</div>
						<div class="price-btn">
							<div class="certificate-item-price">
								<div class="newPrice">￥{{ item.sellPrice }}<span>元/本</span></div>
								<div class="oldPrice">￥{{ item.marketPrice }}元/本</div>
							</div>

							<div class="certificate-item-button">
								<el-button type="primary" style="max-width: 90px;"
									@click="jump('handling_detail?id=' + item.id)">办证</el-button>
							</div>
						</div>

					</div>

				</div>
			</div>
			<div style="padding:3.125vw 0 6.25vw;text-align:center;">
				<el-pagination background layout="prev, pager, next" @current-change="commonChange" :page-size="12"
					@prev-click="prevClick" @next-click="nextClick" :total="total">
				</el-pagination>
			</div>
			<tab-bottom ref="bottom"></tab-bottom>
		</div>
	</div>
</template>

<script>
import adver from '@/pages/advertisement.vue';
import BaseMixin from '@/mixins/BaseMixin.vue'
import PageMixin from '@/mixins/PageMixin.vue'
import tabBottom from '@/pages/bottom.vue'
export default {
	mixins: [BaseMixin, PageMixin],
	data() {
		return {
			select: '',
			selectList: [],
			input: "",
			certificate: [],
			currentPage: {
				page: 0,
				size: 12,
			},
			total: 0
		}
	},
	components: {
		tabBottom,
		adver
	},
	methods: {
		initData() {
			this.$u.api.pagerCategory().then(res => {
				let info = res.data.content
				if (info.length > 0) {
					for (let i = 0; i < info.length; i++) {
						info[i].value = info[i].id
						let infos = info[i].children || []
						for (let z = 0; z < infos.length; z++) {
							infos[z].value = infos[z].id
						}
					}
				}
				info.forEach(e => {
					this.selectList.push(e)
				})
			})
			this.pageApi = this.$u.api.pagerList
			this.initList()
		},
		search() {
			this.searchForm.name = this.input
			this.initList()
		},
		handleChange(e) {
			const id = e[e.length - 1]
			if (id) {
				this.searchForm.path = id
			} else {
				delete this.searchForm.path
			}
			this.initList()
		},
		commonChange(e) {
			this.currentPage.page = e - 1
			this.getList()
		},
		prevClick(e) {
			this.currentPage.page = e + 1
			this.getList()
		},
		nextClick(e) {
			this.currentPage.page = e - 1
			this.getList()
		}
	}
}
</script>
<style>
page {
	background: none;
}
</style>
<style lang="less" scoped>
.certificate {
	margin: 0  auto; width:68.5vw;
	background: #fff;
	box-shadow: 0px 16px 26px 0px rgba(6, 27, 51, 0.13);

	.certificate-search {
		position: relative;
		display: flex;
		padding-top: 3.125vw;
		margin: 0 10.4167vw 0;

		.el-button {
			position: absolute;
			right: 0;
			width: 5.729vw;
		}
	}

	.certificate-list {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		color: #333333;
		padding: 0 1.5vw;

		.certificate-item {
			width: 45%;
			padding: 1.5625vw 1.25vw;
			background: #fff;
			display: flex;
			align-items: center;
			margin-top: 2.083vw;
			font-size: 0.729vw;
			box-shadow: 0px 3px 18px 0px rgba(1, 22, 46, 0.08);

			.certificate-item-img img {
				width: 5.729vw;
				height: 6.25vw;
				margin-right: 1.04167vw;
			}

			.certificate-item-title {
				font-size: 1.041vw;
				margin-bottom: 0.833vw;
			}

			.certificate-item-name {
				margin-bottom: 1.7708vw;
			}

			.price-btn {
				display: flex;
				justify-content: space-between;
				align-items: center;

				.certificate-item-price {
					font-size: 0.833vw;
					display: flex;
					align-items: center;

					.newPrice {
						color: #F95022;
						font-size: 1.354vw;
					}

					.oldPrice {
						margin-left: 0.729vw;
						text-decoration: line-through;
					}
				}
			}


		}

		&:after {
			content: "";
			width: 31%;
			height: 0px;
			visibility: hidden;
		}
	}
}
</style>